import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ResourceHero from './components/ResourceHero';
import ValueProposition from './components/ValueProposition';
import ResourceChecklist from './components/ResourceChecklist';
import AdditionalConsiderations from './components/AdditionalConsiderations';
import ResourceCTA from './components/ResourceCTA';

export default function ResourcesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ResourceHero />
      <ValueProposition />
      <ResourceChecklist />
      <AdditionalConsiderations />
      <ResourceCTA />
      <Footer />
    </div>
  );
}